module.exports = __webpack_public_path__ + "img/light-preloader-novikov.cdcfe1e.gif";